import { clsx } from "clsx";
import Svg from "react-inlinesvg";

import { T } from "@repo/transifex";
import { useCurrentSupplier } from "~/api/suppliers/hooks/use-supplier";
import { Welcome } from "~/components/pos/basket/welcome";
import { KanplaLogo } from "~/components/KanplaLogo";

export const BasketWelcome = () => {
  const { data: supplier, status } = useCurrentSupplier();

  const { svg, url } = supplier?.logo || {};

  return (
    <Welcome description={<T _str="Choose which company you belong to" />}>
      <div
        className={clsx(
          "mb-8 flex aspect-square h-40 items-center justify-center self-center"
        )}
      >
        {/** Logo - url */}
        {status === "success" && url ? (
          <img alt="logo" src={url} className="size-full object-contain" />
        ) : null}

        {/** Logo - svg */}
        {status === "success" && !url && svg ? (
          <Svg fill="currentColor" height="100%" src={svg} width="100%" />
        ) : null}

        {/** Default - Kanpla Logo */}
        {status !== "pending" && !svg && !url && <KanplaLogo />}
      </div>
    </Welcome>
  );
};
